<template>
  <div class="category-section">
    <div class="category-grid">
      <div 
        v-for="category in categories" 
        :key="category.id"
        class="category-card" 
        :class="{ active: selectedCategory === category.id }"
        @click="selectCategory(category.id)"
      >
        <div class="category-icon" :class="`icon-${category.id}`">
          {{ category.icon }}
        </div>
        <div class="category-name">{{ category.name }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CategoryTabs',
  
  data() {
    return {
      selectedCategory: 'basic',
      categories: [
        { id: 'basic', name: '基础课', icon: '📚' },
        { id: 'core', name: '核心课', icon: '🎯' },
        { id: 'extend', name: '拓展课', icon: '🔧' },
        { id: 'practice', name: '实训课', icon: '🏗️' }
      ]
    }
  },
  
  methods: {
    selectCategory(id) {
      this.selectedCategory = id
      this.$emit('category-change', id)
    }
  }
}
</script>

<style scoped>
.category-section {
  margin-bottom: 40px;
}

.category-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(80px, 1fr));
  gap: 16px;
  max-width: 600px;
  margin: 0 auto;
}

.category-card {
  background: var(--bg-glass);
  backdrop-filter: blur(var(--blur-md));
  -webkit-backdrop-filter: blur(var(--blur-md));
  border: 1px solid var(--border-light);
  border-radius: var(--radius-md);
  padding: 20px 12px;
  text-align: center;
  box-shadow: var(--shadow-md);
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.category-card:hover {
  transform: translateY(-4px);
  box-shadow: var(--shadow-lg);
  border-color: rgba(0, 122, 255, 0.2);
}

.category-card.active {
  background: var(--primary);
  color: white;
  transform: translateY(0);
}

.category-card.active .category-icon {
  background: rgba(255, 255, 255, 0.2);
}

.category-card.active .category-name {
  color: white;
}

.category-icon {
  width: 56px;
  height: 56px;
  margin: 0 auto 12px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
}

.icon-basic { background: linear-gradient(135deg, #ffeaa7, #fdcb6e); }
.icon-core { background: linear-gradient(135deg, #a29bfe, #6c5ce7); }
.icon-extend { background: linear-gradient(135deg, #55efc4, #00b894); }
.icon-practice { background: linear-gradient(135deg, #ff7675, #d63031); }

.category-name {
  font-size: 14px;
  color: var(--text-dark);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 600;
  letter-spacing: -0.01em;
}

@media (max-width: 768px) {
  .category-grid {
    max-width: 800px;
    grid-template-columns: repeat(4, 1fr);
  }
}
</style>